import NotificationsRepository from './NotificationsRepository';

export default NotificationsRepository;
